"use strict";

exports.__esModule = true;
exports.EditableDeviceDataTableElement = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _Core = require("../../Core");
var _DataSources = require("../DataTable/DataSources");
var _helpers = require("../DataTable/helpers");
var _Device = require("../../Device");
var _PlantStateActivities = require("../../PlantStateActivities");
var _DeviceDataTable = require("./DeviceDataTable");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var EditableDeviceDataTableElement = exports.EditableDeviceDataTableElement = (0, _reactRouterCompat.withRouter)(function (props) {
  var pageSizeList = [25, 100, 500, 1000];
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var width = props.width,
    height = props.height,
    pageSizes = props.pageSizes,
    children = props.children;
  var columns = children.map(function (_ref) {
    var props = _ref.props;
    return props;
  });
  var defaultPageSize = (pageSizes == null ? void 0 : pageSizes.at(0)) || pageSizeList[0];
  var devices = _react["default"].useContext(_Device.DeviceListContext);
  var plantStateActivities = _react["default"].useContext(_PlantStateActivities.PlantStateActivitiesContext);
  var columnsConfig = children.map(function (child) {
    return child.props;
  });
  var defaultSorted = (0, _helpers.getDefaultSortOrder)(columnsConfig);
  var defaultFilters = (0, _helpers.getDefaultFilters)(columnsConfig, {
    devices: devices,
    plantStateActivities: plantStateActivities
  });
  var deviceDataDefinition = _DataSources.DataSourceDefinitions["deviceData"](translate);
  var data = [];
  var rowFormatters = deviceDataDefinition.rowFormatters;
  return /*#__PURE__*/_react["default"].createElement(_DeviceDataTable.DeviceDataTable, {
    columns: columns,
    data: data,
    height: height,
    width: width,
    defaultSorted: defaultSorted.map(function (_ref2) {
      var id = _ref2.id,
        desc = _ref2.desc;
      return {
        id: id,
        desc: desc
      };
    }),
    defaultFiltered: defaultFilters,
    defaultPageSize: defaultPageSize,
    rowFormatters: rowFormatters,
    pageSizeOptions: pageSizes || pageSizeList,
    noDataText: translate("DataTable.SwitchToViewMode", "Switch to view mode in order to see data")
  });
});